import { useState, useEffect } from 'react';

export const useAuth = () => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('user') || 'null');
    } catch {
      return null;
    }
  });

  const [organization, setOrganization] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem('organization') || 'null');
    } catch {
      return null;
    }
  });

  const getToken = async () => {
    // First try localStorage
    const localToken = localStorage.getItem('auth_token');
    if (localToken) return localToken;

    // Then try sessionStorage
    const sessionToken = sessionStorage.getItem('auth_token');
    if (sessionToken) return sessionToken;

    // If no token found, return null
    return null;
  };

  const setToken = (token: string, remember: boolean = false) => {
    if (remember) {
      localStorage.setItem('auth_token', token);
    } else {
      sessionStorage.setItem('auth_token', token);
    }
  };

  const removeToken = () => {
    localStorage.removeItem('auth_token');
    sessionStorage.removeItem('auth_token');
  };

  const updateUser = (userData: any) => {
    if (userData) {
      localStorage.setItem('user', JSON.stringify(userData));
      setUser(userData);
    }
  };

  const updateOrganization = (orgData: any) => {
    if (orgData) {
      localStorage.setItem('organization', JSON.stringify(orgData));
      setOrganization(orgData);
    }
  };

  const clearAuth = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('organization');
    localStorage.removeItem('auth_token');
    sessionStorage.removeItem('auth_token');
    setUser(null);
    setOrganization(null);
  };

  // Effect to sync state with localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      const storedUser = localStorage.getItem('user');
      const storedOrg = localStorage.getItem('organization');
      
      try {
        setUser(storedUser ? JSON.parse(storedUser) : null);
        setOrganization(storedOrg ? JSON.parse(storedOrg) : null);
      } catch (error) {
        console.error('Error parsing stored auth data:', error);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    user,
    organization,
    getToken,
    setToken,
    removeToken,
    updateUser,
    updateOrganization,
    clearAuth,
    isAuthenticated: !!user
  };
};

export default useAuth; 